import { ContentLayout } from "@/components/Layout";
import { Authorization, ROLES } from "@/libs/authorization";
import { ViewAdvertScreen } from "../components";
import { Header } from "../components/advert";

export const ViewAdvert = () => {
  return (
    <ContentLayout title="Adverts" header={<Header />}>
      <div className="bg-white flex mb-6 rounded-2xl flex-col dark:bg-slate-900/70">
        <div className="flex-1">
          <Authorization
            forbiddenFallback={<div>Only Merchant can view this.</div>}
            allowedRoles={[ROLES.MERCHANT]}
          >
            <ViewAdvertScreen />
          </Authorization>
        </div>
      </div>
    </ContentLayout>
  );
};
